import { render, staticRenderFns } from "./teachersList.vue?vue&type=template&id=6b251f3f&"
import script from "./teachersList.vue?vue&type=script&lang=js&"
export * from "./teachersList.vue?vue&type=script&lang=js&"
import style0 from "./teachersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports